module.exports = __webpack_public_path__ + "static/media/panang-chicken.2c62d5e8.jpg";